import React from 'react';

import { AdornedInput, Adornment, FormField, FormHelp, Input, Label, Textarea } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import type { HTMLElementEvent } from '../../../../models/Types';
import { PROPERTY_TYPE } from '../../../../constants';
import { stopPropagationIfInvalidNumber } from '../../../../utils/validatorTypes/PositiveIntegerValidator';

export function isMultiFamily(section: Section): boolean {
  return section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY) === true;
}

type Props = {
  section: Section;
  utilityName: string;
  percentageFieldName: string;
  formulaFieldName: string;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function MultiFamilyLandlordUtility({
  formulaFieldName,
  percentageFieldName,
  section,
  setSectionValues,
  utilityName,
}: Props): JSX.Element {
  function onPercentageChange(event: HTMLElementEvent<typeof Input>): void {
    const value = event.currentTarget.value;

    setSectionValues({
      [percentageFieldName]: value,
    });
  }

  function onFormulaChange(event: HTMLElementEvent<typeof Input>): void {
    const value = event.currentTarget.value;

    setSectionValues({
      [formulaFieldName]: value,
    });
  }

  return (
    <>
      <FormField marginBottom="sm">
        <Label>{`What percentage of the monthly ${utilityName} cost will you bill the tenant?`}</Label>
        <AdornedInput
          inputId="AdornedInput-Percentage-Of-Monthly-Bill"
          input={
            <Input
              aria-label="Enter percentage"
              onKeyDown={stopPropagationIfInvalidNumber}
              onChange={onPercentageChange}
              placeholder="Enter percentage"
              type="number"
            />
          }
          rightAdornment={<Adornment>%</Adornment>}
        />
      </FormField>
      <FormField>
        <Label>{`What is your utilities allocation formula for ${utilityName}?`}</Label>
        <Textarea
          aria-label="Utilities allocation formula"
          resize="vertical"
          value={section.getFieldValue(formulaFieldName)}
          onChange={onFormulaChange}
          placeholder="Enter formula"
        />
        <FormHelp>
          Explain formula used to determine percentage. Example: The building has 5 units. The tenant lives in 1, so
          their share is 1/5 (or 20%) of the total cost.
        </FormHelp>
      </FormField>
    </>
  );
}
